import React from "react";
import { LinearProgress } from "@mui/material";

const Loading = (props) => {

    return <LinearProgress {...props}/>
}

export default Loading